import { NavLink, useNavigate } from "react-router-dom";

export default function BottomNav() {
  const navigate = useNavigate();

  const baseButtonStyle = {
    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    color: '#0f172a',
    fontWeight: 600,
    padding: '0.55rem 0.95rem',
    borderRadius: '12px',
    boxShadow: '0 6px 14px rgba(15,23,42,0.08)',
  };

  const activeButtonStyle = {
    ...baseButtonStyle,
    background: 'linear-gradient(135deg, #2563eb, #22c55e)',
    color: '#0b1220',
    border: 'none',
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav
      className="fixed-bottom"
      role="navigation"
      aria-label="Bottom navigation"
      style={{
        background: '#ffffff',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid #e5e7eb',
        boxShadow: '0 -8px 30px rgba(15,23,42,0.08)',
        padding: '0.6rem 0.75rem',
      }}
    >
      <div className="container-fluid d-flex justify-content-center">
        <div className="d-flex gap-2 flex-wrap" role="group" aria-label="Bottom nav buttons">
          <NavLink
            to="/dashboard"
            style={({ isActive }) => (isActive ? activeButtonStyle : baseButtonStyle)}
            className="text-decoration-none"
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/Users"
            style={({ isActive }) => (isActive ? activeButtonStyle : baseButtonStyle)}
            className="text-decoration-none"
          >
            Users
          </NavLink>

          <NavLink
            to="/notifications"
            style={({ isActive }) => (isActive ? activeButtonStyle : baseButtonStyle)}
            className="text-decoration-none"
          >
            BroadCaster
          </NavLink>

          <NavLink
            to="/categories"
            style={({ isActive }) => (isActive ? activeButtonStyle : baseButtonStyle)}
            className="text-decoration-none"
          >
            Categories
          </NavLink>

          <NavLink
            to="/settings"
            style={({ isActive }) => (isActive ? activeButtonStyle : baseButtonStyle)}
            className="text-decoration-none"
          >
            Settings
          </NavLink>

          <button
            type="button"
            onClick={handleLogout}
            className="border-0"
            style={baseButtonStyle}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
